<template>
  <div class="p-the-header-user-navi">
    <button
      type="button"
      class="p-the-header-user-navi__button"
      @click.stop
      @click="switchShownState"
    >
      <IconBase
        :width="24"
        :height="24"
        view-box="0 0 24 24"
        icon-color="#000000"
      >
        <IconHamburger />
      </IconBase>
    </button>

    <transition v-if="!isAdmin" name="fade">
      <ul
        v-show="profileNavi.shown"
        class="p-the-header-user-navi__list c-common-rounded-shadow"
        @click.stop
      >
        <li class="p-the-header-user-navi__list__item">
          <a
            v-touch:tap
            :href="urls.mypage"
            class="
              p-the-header-user-navi__list__link
              c-common-rounded-shadow__label
            "
          >
            <i class="p-the-header-user-navi__list__icon">
              <IconBase :width="24" :height="24" view-box="0 0 24 24">
                <IconHumanWithOutline />
              </IconBase>
            </i>
            <span class="p-the-header-user-navi__list__text">マイページ</span>
          </a>
        </li>
        <li class="p-the-header-user-navi__list__item">
          <a
            v-touch:tap
            :href="urls.pointConfirmation"
            class="
              p-the-header-user-navi__list__link
              c-common-rounded-shadow__label
            "
          >
            <i class="p-the-header-user-navi__list__icon">
              <IconBase :width="24" :height="24" view-box="0 0 24 24">
                <IconPointDefault
                  :icon-color="'#ffff'"
                  :border-color="'#3c3c3c'"
                  :bg-color="'#3c3c3c'"
                />
              </IconBase>
            </i>
            <span class="p-the-header-user-navi__list__text">ポイント確認</span>
          </a>
        </li>
        <li
          v-if="thanksFunctionEnabled && !isGroupBudget"
          class="p-the-header-user-navi__list__item"
        >
          <a
            v-touch:tap
            :href="urls.thanksPoint"
            class="
              p-the-header-user-navi__list__link
              c-common-rounded-shadow__label
            "
          >
            <i class="p-the-header-user-navi__list__icon">
              <IconBase
                :width="24"
                :height="24"
                view-box="0 0 24 24"
                icon-color="#3c3c3c"
              >
                <IconThanksMessage />
              </IconBase>
              <span class="p-the-header__right__notification">
                <TextLabelNewArrivalCount
                  v-if="thanksPointUnreadCount > 0"
                  :count="thanksPointUnread"
                />
              </span>
            </i>
            <span class="p-the-header-user-navi__list__text"
              >{{ thanksPointName }}メッセージ</span
            >
          </a>
        </li>
        <li class="p-the-header-user-navi__list__item">
          <a
            v-touch:tap
            :href="urls.whatsNew"
            class="
              p-the-header-user-navi__list__link
              c-common-rounded-shadow__label
            "
          >
            <i class="p-the-header-user-navi__list__icon">
              <IconBase
                :width="24"
                :height="24"
                view-box="0 0 24 24"
                icon-color="#3c3c3c"
              >
                <IconNotification />
              </IconBase>
              <span class="p-the-header__right__notification">
                <TextLabelNewArrivalCount
                  v-if="whatsNewUnreadCount > 0 && !isGroupBudget"
                  :count="whatsNewUnread"
                />
              </span>
            </i>
            <span class="p-the-header-user-navi__list__text">お知らせ</span>
          </a>
        </li>
        <li class="p-the-header-user-navi__list__item">
          <a
            v-touch:tap
            :href="urls.orders"
            class="
              p-the-header-user-navi__list__link
              c-common-rounded-shadow__label
            "
          >
            <i class="p-the-header-user-navi__list__icon">
              <IconBase
                :width="24"
                :height="24"
                view-box="0 0 24 24"
                icon-color="#3c3c3c"
              >
                <IconOrderHistory />
              </IconBase>
            </i>
            <span class="p-the-header-user-navi__list__text">申込履歴</span>
          </a>
        </li>
        <li class="p-the-header-user-navi__list__item">
          <a
            v-touch:tap
            :href="urls.visit"
            class="
              p-the-header-user-navi__list__link
              c-common-rounded-shadow__label
            "
          >
            <i class="p-the-header-user-navi__list__icon">
              <IconBase
                :width="24"
                :height="24"
                view-box="0 0 24 24"
                icon-color="#3c3c3c"
              >
                <IconHistoryLog />
              </IconBase>
            </i>
            <span class="p-the-header-user-navi__list__text">閲覧履歴</span>
          </a>
        </li>
        <li class="p-the-header-user-navi__list__item">
          <a
            v-touch:tap
            :href="urls.favorites"
            class="
              p-the-header-user-navi__list__link
              c-common-rounded-shadow__label
            "
          >
            <i class="p-the-header-user-navi__list__icon">
              <IconBase
                :width="24"
                :height="24"
                view-box="0 0 24 24"
                icon-color="#3c3c3c"
              >
                <IconHeart />
              </IconBase>
            </i>
            <span class="p-the-header-user-navi__list__text">お気に入り</span>
          </a>
        </li>
        <li
          v-if="!showMailSettings && !isGroupBudget"
          class="p-the-header-user-navi__list__item"
        >
          <a
            v-touch:tap
            :href="urls.mailSettings"
            class="
              p-the-header-user-navi__list__link
              c-common-rounded-shadow__label
            "
          >
            <i class="p-the-header-user-navi__list__icon">
              <IconBase
                :width="24"
                :height="24"
                view-box="0 0 24 24"
                icon-color="transparent"
              >
                <IconMail />
              </IconBase>
            </i>
            <span class="p-the-header-user-navi__list__text"
              >メール受信設定</span
            >
          </a>
        </li>
        <li class="p-the-header-user-navi__list__item">
          <a
            v-touch:tap
            :href="urls.faq"
            class="
              p-the-header-user-navi__list__link
              c-common-rounded-shadow__label
            "
          >
            <i class="p-the-header-user-navi__list__icon">
              <IconBase
                :width="24"
                :height="24"
                view-box="0 0 24 24"
                icon-color="#3c3c3c"
              >
                <IconFaqBalloon />
              </IconBase>
            </i>
            <span class="p-the-header-user-navi__list__text">FAQ</span>
          </a>
        </li>
        <li class="p-the-header-user-navi__list__item">
          <a
            v-touch:tap
            :href="urls.qa"
            class="
              p-the-header-user-navi__list__link
              c-common-rounded-shadow__label
            "
          >
            <i class="p-the-header-user-navi__list__icon">
              <IconBase
                :width="24"
                :height="24"
                view-box="0 0 24 24"
                icon-color="transparent"
              >
                <IconMail />
              </IconBase>
            </i>
            <span class="p-the-header-user-navi__list__text">お問い合わせ</span>
          </a>
        </li>
        <li class="p-the-header-user-navi__list__item">
          <a
            v-touch:tap
            href="javascript:void(0);"
            class="
              p-the-header-user-navi__list__link
              c-common-rounded-shadow__label
            "
            @click.prevent="emitLogout"
          >
            <i class="p-the-header-user-navi__list__icon">
              <IconBase
                :width="24"
                :height="24"
                view-box="0 0 24 24"
                icon-color="transparent"
              >
                <IconLogout :icon-color="'#3c3c3c'" />
              </IconBase>
            </i>
            <span class="p-the-header-user-navi__list__text">ログアウト</span>
          </a>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconHumanWithOutline from "@/common/components/icons/IconHumanWithOutline.vue";
import IconBarGraph from "@/common/components/icons/IconBarGraph.vue";
import IconPointDefault from "@/common/components/icons/IconPointDefault.vue";
import IconThanksMessage from "@/common/components/icons/IconThanksMessage.vue";
import IconLogout from "@/common/components/icons/IconLogout.vue";
import IconNotification from "@/common/components/icons/IconNotification.vue";
import IconHeart from "@/common/components/icons/IconHeart.vue";
import IconOrderHistory from "@/common/components/icons/IconOrderHistory.vue";
import IconHistoryLog from "@/common/components/icons/IconHistoryLog.vue";
import IconMail from "@/common/components/icons/IconMail.vue";
import IconFaqBalloon from "@/common/components/icons/IconFaqBalloon.vue";
import IconHamburger from "@/common/components/icons/IconHamburger.vue";
import TextLabelNewArrivalCount from "@/common/components/atoms/TextLabelNewArrivalCount.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";
import modalState from "@/common/store/modules/modalState";

import { karteLogin } from "@/common/assets/js/karte/";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";

import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";

@Options({
  name: "TheHeaderUserNavi",
  props: {
    thanksPointUnreadCount: { type: Number, required: true, default: 0 },
    whatsNewUnreadCount: { type: Number, required: true, default: 0 }
  },
  components: {
    IconBase,
    IconUserImage,
    IconHumanWithOutline,
    IconLogout,
    IconThanksMessage,
    IconNotification,
    IconHeart,
    IconOrderHistory,
    IconHistoryLog,
    IconMail,
    IconFaqBalloon,
    TextLabelNewArrivalCount,
    IconBarGraph,
    IconPointDefault,
    IconHamburger
  },
  watch: {
    closeModalState() {
      this.profileNavi.shown = false;
    }
  }
})
export default class TheHeaderUserNavi extends Vue {
  thanksPointUnreadCount!: number;
  whatsNewUnreadCount!: number;
  profileNavi = {
    shown: false
  };

  userInfo = commons.userInfo;

  get closeModalState() {
    return modalState.closeModalState;
  }

  switchShownState() {
    const shown = this.profileNavi.shown;
    this.profileNavi.shown = !shown;
  }

  emitLogout() {
    this.$emit("logout");
  }

  get thanksPointUnread() {
    const total = this.thanksPointUnreadCount;
    return total >= CONST_DATA.LIMITS.UNREAD_COUNT_DISPLAY_LIMIT ? "..." : total;
  }

  get whatsNewUnread() {
    const total = this.whatsNewUnreadCount;
    return total >= CONST_DATA.LIMITS.UNREAD_COUNT_DISPLAY_LIMIT ? "..." : total;
  }

  get thanksFunctionEnabled() {
    return commons.thanksFunctionEnabled;
  }

  get isAdmin() {
    return false;
  }

  get urls() {
    return {
      whatsNew: CONST_DATA.SITE_MAP.WHATS_NEW,
      favorites: process.env.VUE_APP_MYPAGE + "/favorites/",
      orders: process.env.VUE_APP_MYPAGE + "/orders",
      visit: process.env.VUE_APP_MYPAGE + "/visits/",
      pointConfirmation: CONST_DATA.SITE_MAP.POINT_CONFIRMATION,
      thanksPoint: CONST_DATA.SITE_MAP.THANKS_POINT,
      mailSettings: CONST_DATA.SITE_MAP.MAIL_DELIVERY_SETTINGS,
      qa:
        process.env.VUE_APP_BS_DOMAIN + "/contents/cgi/memberfaqic/index.html",
      faq: process.env.VUE_APP_BS_DOMAIN + "/contents/cgi/incentive/faq3/",
      mypage: process.env.VUE_APP_MYPAGE
    };
  }

  get showMailSettings() {
    return (
      !auth.user.approval_result_notification_mail &&
      !auth.user.point_expiry_notification_enabled &&
      !auth.user.point_balance_notification_enabled &&
      !auth.user.point_receipt_notification_enabled &&
      !auth.user.mail_magazine_enabled
    );
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }

  async logout() {
    karteLogin(false);

    await fetch(commons.LOGOUT_URL, { method: "POST" })
      .then(() => {
        window.sessionStorage.clear();
        // window.localStorage.clear();
        LocalStorage.removeAll();
        window.location.href = "/logout";
      })
      .catch(() => {
        window.sessionStorage.clear();
        // window.localStorage.clear();
        LocalStorage.removeAll();
        window.location.href = "/logout";
      });
  }
}
</script>

<style lang="scss" scoped>
.p-the-header-user-navi {
  &__button {
    width: rem(36);
    height: rem(36);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__list {
    position: absolute;
    top: rem(14 + 36);
    right: rem(-8);
    width: rem(188);
    z-index: 2;

    &__item {
      position: relative;
    }

    &__link {
      width: 100%;
      padding: rem(8) rem(12);
      font-size: rem(14);
      font-weight: bold;
      display: flex;
      align-items: center;
    }

    &__icon {
      line-height: 1;
      margin-right: rem(4);
      position: relative;
    }

    &__text {
      width: rem(136);
      overflow-wrap: break-word;
      line-height: 1.6;
    }
  }
}
</style>
